import { ServiceLogo } from '@on3/ui-lib/components/ServiceLogo/ServiceLogo';
import { TheAthletic } from '@on3/ui-lib/components/Svg/TheAthletic';

import styles from './JoinTheAthletic.module.scss';

export const JoinTheAthletic = () => {
  return (
    <section className={styles.block}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.logos}>
            <ServiceLogo className={styles.on3} type="on3" />
            <div className={styles.divider} />
            <TheAthletic className={styles.athletic} />
          </div>
          <h2 className="sr-only">
            Get The Athletic access with your Annual On3 subscription
          </h2>
          <p className={styles.title}>Now included with Annual</p>
          <p className={styles.description}>
            As an On3 annual subscriber, you now get full access to The
            Athletic, bringing you world-class coverage of NFL, NBA, NASCAR and
            more alongside On3&apos;s industry-leading coverage of college and
            high school sports.
          </p>
        </div>
        <div className={styles.image}>
          <img
            alt="The Athletic screen samples"
            src="https://on3static.com/static/on3/the-athletic-on3-screens.png"
          />
        </div>
      </div>
    </section>
  );
};
